const SERVER = import.meta.env.VITE_API_URL;
import axios from "../configs/axios.config";

// Utility function to sanitize token
const sanitizeToken = (token) => {
  if (!token || token === "undefined" || token === "null") {
    return null;
  }
  token = token.trim();
  // Remove surrounding quotes if present
  if (
    (token.startsWith('"') && token.endsWith('"')) ||
    (token.startsWith("'") && token.endsWith("'"))
  ) {
    token = token.slice(1, -1);
  }
  return token;
};

//vehicle

// const postNewVehicleSegment = async (formData) => {
//   try {
//     const token = localStorage.getItem("prima_session");

//     if (!token) {
//       throw new Error("Token not found");
//     }

//     let response = await fetch(`${SERVER}/management/vehicle-segment`, {
//       method: "POST",
//       headers: {
//         Authorization: `Bearer ${token}`,

//       },
//       body: formData,
//     });

//     if (response.status === 401 || response.status === 403) {
//       throw new Error("Unauthorized user");
//     }

//     if (!response.ok) {
//       throw new Error("Failed to fetch data");
//     }

//     let data = await response.json();
//     return data;
//   } catch (error) {
//     console.error("Error in postNewVehicleSegment:", error.message);
//     throw new Error(error.message);
//   }
// };

const getAuthToken = () => {
  const token = localStorage.getItem("prima_session");
  if (!token) {
    throw new Error("Token not found. Please login again.");
  }
  return token;
};

const postNewVehicleSegment = async (formData) => {
  try {
    const token = getAuthToken();

    // console.log("=== DEBUGGING INFO ===");
    console.log("Token exists:", !!token);
    // console.log("FormData entries:");
    // for (let pair of formData.entries()) {
    //   if (pair[1] instanceof File) {
    //     console.log(
    //       `${pair[0]}: File(${pair[1].name}, ${pair[1].size} bytes, ${pair[1].type})`,
    //     );
    //   } else {
    //     console.log(`${pair[0]}:`, pair[1]);
    //   }
    // }
    // console.log("======================");

    const response = await axios.post(
      `${SERVER}/management/vehicle-segment`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    // console.log("Success Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("=== ERROR DETAILS ===");
    console.error("Error:", error);

    if (error.response) {
      console.error("Response Status:", error.response.status);
      console.error("Response Data:", error.response.data);
      console.error("Response Headers:", error.response.headers);

      if (error.response.status === 401 || error.response.status === 403) {
        throw new Error("Unauthorized user. Please login again.");
      }

      const serverMessage =
        error.response.data?.message ||
        error.response.data?.error ||
        JSON.stringify(error.response.data);
      throw new Error(`Server Error: ${serverMessage}`);
    } else if (error.request) {
      console.error("No response received");
      console.error("Request:", error.request);
      throw new Error("No response from server. Please check your connection.");
    } else {
      console.error("Request setup error:", error.message);
      throw new Error(error.message);
    }
  }
};

const fetchAllVehiclesList = async () => {
  try {
    const token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }

    const response = await axios.get(
      `${SERVER}/management/vehicle-segments?page=1&limit=10000`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data?.message || "API Error");
    } else {
      throw new Error(error.message);
    }
  }
};

const editAVehicleSegment = async (formData, id) => {
  try {
    const rawToken = localStorage.getItem("prima_session");
    // console.log("Raw token from localStorage:", rawToken);

    // Check for invalid values before sanitization
    if (!rawToken || rawToken === "undefined" || rawToken === "null") {
      console.error(
        "No valid token in localStorage. Clearing and forcing re-login.",
      );
      localStorage.removeItem("prima_session");
      throw new Error("Session expired. Please login again.");
    }

    let token = sanitizeToken(rawToken);
    // console.log("Sanitized token:", token);

    if (!token) {
      console.error(
        "Token sanitization failed. Clearing and forcing re-login.",
      );
      localStorage.removeItem("prima_session");
      throw new Error("Session expired. Please login again.");
    }

    // console.log("Editing vehicle segment ID:", id);
    // console.log("Token (first 20 chars):", token.substring(0, 20) + "...");
    // console.log("Token length:", token.length);
    // console.log(
    //   "Authorization header will be:",
    //   `Bearer ${token.substring(0, 20)}...`,
    // );

    // Log FormData contents for debugging
    // console.log("FormData contents:");
    // for (let pair of formData.entries()) {
    //   if (pair[1] instanceof File) {
    //     console.log(`  ${pair[0]}: File(${pair[1].name})`);
    //   } else {
    //     console.log(
    //       `  ${pair[0]}: ${typeof pair[1] === "string" && pair[1].length > 50 ? pair[1].substring(0, 50) + "..." : pair[1]}`,
    //     );
    //   }
    // }

    // console.log("" CODE VERSION: 2026-01-02-v5 ");
    // console.log(
    //   "About to call axios.patch with token:",
    //   token.substring(0, 20) + "...",
    // );

    // Use axios instead of fetch for better FormData handling
    // NOTE: Do NOT set Content-Type manually with FormData - axios sets it automatically with boundary
    // console.log("Sending request with axios...");
    const response = await axios.patch(
      `${SERVER}/management/vehicle-segment/${id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    console.log("Response status:", response.status);
    // console.log("Response data:", response.data);

    return response.data;
  } catch (error) {
    console.error("editAVehicleSegment error:", error);
    throw new Error(error.message);
  }
};

const deleteAVehicleSegment = async (id) => {
  try {
    const token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }

    // console.log(id);
    let response = await fetch(`${SERVER}/management/vehicle-segment/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    if (!response.ok) {
      throw new Error("Failed to fetch data");
    }

    let data = await response.json();
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

const fetchOneVehicleSegment = async (id) => {
  try {
    const token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }

    const response = await axios.get(
      `${SERVER}/management/vehicle-segment/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data?.message || "API Error");
    } else {
      throw new Error(error.message);
    }
  }
};

// customer ==========================================

const fetchAllCustomersList = async ({ page = 1, limit = 10 } = {}) => {
  try {
    const token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }

    const response = await axios.get(
      `${SERVER}/management/customers`,
      {
        params: { page, limit },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

const fetchOneCustomerSegment = async (id) => {
  try {
    const token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }

    const response = await axios.get(`${SERVER}/management/customer?id=${id}`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data?.message || "API Error");
    } else {
      throw new Error(error.message);
    }
  }
};

const editOneCustomerSegment = async (formData, id) => {
  try {
    const token = localStorage.getItem("prima_session");
    if (!token) {
      throw new Error("Token not found");
    }

    const response = await axios.patch(
      `${SERVER}/management/customer/${id}`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(
        error.response.data.message || "Failed to update customer",
      );
    }
    throw new Error(error.message);
  }
};

const deleteOneCustomerSegment = async (id) => {
  console.log("Deleting customer with ID:", id);

  try {
    const token = localStorage.getItem("prima_session");
    if (!token) {
      throw new Error("Token not found");
    }

    const response = await axios.delete(`${SERVER}/management/customer/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(
        error.response.data.message || "Failed to delete customer",
      );
    }
    throw new Error(error.message);
  }
};

// custom -booking

const createCustomBooking = async (formData) => {
  try {
    const token = localStorage.getItem("prima_session");
    if (!token) {
      throw new Error("Token not found");
    }

    const response = await axios.post(
      `${SERVER}/management/custom-booking`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    // console.log("Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const fetchAllCustomBookingList = async () => {
  try {
    const token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }

    const response = await axios.get(`${SERVER}/management/bookings`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

// customer add

const addcustomer = async (formData) => {
  try {
    const token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }

    const response = await axios.post(
      `${SERVER}/management/customer`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

//packages===================================

// const postNewPackage = async (formData) => {
//     console.log("postNewPackage called with formData:", formData);
//     try {
//         const token = localStorage.getItem("prima_session");
//           if (!token) {
//       throw new Error("Authentication token not found. Please login first.");
//     }
//         let response = await fetch(`${SERVER}/management/package`, {
//             method: "POST",
//             headers: {
//                 Authorization: `Bearer ${token}`
//             },
//             body: formData
//         });
//         console.log("Response Status:", response.status);

//         if (response.status === 401 || response.status === 403) {
//             throw new Error("Unauthorized user");
//         }

//         if (!response.ok) {
//             throw new Error("Failed to create package");
//         }

//         let data = await response.json();
//         return data;

//     } catch (error) {
//         console.error("Error in postNewPackage:", error.message);
//         throw new Error(error.message);
//     }
// };

const postNewPackage = async (formData) => {
  console.log("postNewPackage called with formData:", formData);

  console.log("FormData entries:");
  for (let [key, value] of formData.entries()) {
    if (value instanceof File) {
      console.log(
        `  ${key}: File - ${value.name} (${value.type}, ${value.size} bytes)`,
      );
    } else {
      console.log(`  ${key}: ${value}`);
    }
  }

  try {
    const token = localStorage.getItem("prima_session");
    if (!token) {
      throw new Error("Authentication token not found. Please login first.");
    }

    console.log(
      "Token found, making request to:",
      `${SERVER}/management/package`,
    );

    const response = await axios.post(
      `${SERVER}/management/package`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          // Don't set Content-Type - let axios set it with proper boundary
        },
      },
    );

    console.log("Response Status:", response.status);
    console.log("Response Body:", response.data);

    if (response.data?.success) {
      console.log("Package created successfully:", response.data);
      return response.data;
    } else {
      throw new Error(response.data?.message || "Failed to create package");
    }
  } catch (error) {
    console.error("Error in postNewPackage:", error);
    console.error("Error response:", error.response?.data);

    // Handle specific error messages from backend
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }

    throw error;
  }
};

const getOnePackage = async (id) => {
  try {
    const token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }

    console.log(`[getOnePackage] Fetching package with ID: ${id}`);

    const response = await axios.get(`${SERVER}/management/package?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("[getOnePackage] Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("[getOnePackage] Error:", error);
    throw new Error(error.response?.data?.message || error.message);
  }
};

const updatePackage = async (formData) => {
  try {
    const token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Authentication token not found. Please login first.");
    }

    // Get the ID from FormData
    const id = formData.get("id");
    if (!id) {
      throw new Error("Package ID is required for update");
    }

    console.log("Updating package with ID:", id);
    console.log("FormData entries:");
    for (let [key, value] of formData.entries()) {
      if (value instanceof File) {
        console.log(
          `  ${key}: File - ${value.name} (${value.type}, ${value.size} bytes)`,
        );
      } else {
        console.log(`  ${key}: ${value}`);
      }
    }

    const response = await axios.patch(
      `${SERVER}/management/package?id=${id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          // Don't set Content-Type - let axios set it with proper boundary
        },
      },
    );

    console.log("Update Response Status:", response.status);
    console.log("Update Response Body:", response.data);

    if (response.data?.success) {
      console.log("Package updated successfully:", response.data);
      return response.data;
    } else {
      throw new Error(response.data?.message || "Failed to update package");
    }
  } catch (error) {
    console.error("Error in updatePackage:", error);
    console.error("Error response:", error.response?.data);

    // Handle specific error messages from backend
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }

    throw error;
  }
};

const fetchAllPackages = async (params = {}) => {
  try {
    const token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }

    const response = await axios.get(`${SERVER}/management/packages`, {
      params,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

const deleteOnePackage = async (id) => {
  try {
    const token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }

    console.log(`[deleteOnePackage] Deleting package with ID: ${id}`);

    // Backend expects ID as path parameter (req.params)
    const response = await axios.delete(`${SERVER}/management/package/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("[deleteOnePackage] Delete response:", response.data);

    return response.data;
  } catch (error) {
    console.error("[deleteOnePackage] Error:", error);
    console.error("[deleteOnePackage] Error response:", error.response?.data);

    // Extract error message from axios error response
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to delete package";
    throw new Error(errorMessage);
  }
};

//taxes
const getAllTaxes = async (query) => {
  try {
    const token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }

    const response = await fetch(`${SERVER}/management/tax?search=${query}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    if (!response.ok) {
      throw new Error("Failed to fetch data");
    }

    let data = await response.json();
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

const addNewTax = async (formData) => {
  try {
    const token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }

    const response = await fetch(`${SERVER}/management/tax`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(formData),
    });
    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    if (response.status === 409) {
      throw new Error("Document already exists");
    }

    if (!response.ok) {
      throw new Error("Failed to fetch data");
    }

    let data = await response.json();
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

const editATax = async (formData, id) => {
  try {
    const token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }

    const response = await fetch(`${SERVER}/management/tax/${id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(formData),
    });
    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    if (response.status === 409) {
      throw new Error("Document already exists");
    }

    if (!response.ok) {
      throw new Error("Failed to fetch data");
    }

    let data = await response.json();
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

const deleteATax = async (id) => {
  try {
    const token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }

    const response = await fetch(`${SERVER}/management/tax/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    if (!response.ok) {
      throw new Error("Failed to fetch data");
    }

    let data = await response.json();
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export {
  postNewVehicleSegment,
  fetchAllVehiclesList,
  fetchAllCustomersList,
  fetchOneCustomerSegment,
  editOneCustomerSegment,
  deleteOneCustomerSegment,
  createCustomBooking,
  fetchAllCustomBookingList,
  editAVehicleSegment,
  fetchOneVehicleSegment,
  deleteAVehicleSegment,
  postNewPackage,
  fetchAllPackages,
  updatePackage,
  getOnePackage,
  deleteOnePackage,
  addNewTax,
  editATax,
  deleteATax,
  getAllTaxes,
  addcustomer,
};
